import { connect } from 'react-redux';
import MyProfileCategory from './Main';
import { bindActionCreators } from 'redux';
import { User, drivingCategoryType } from 'Shared/models/UserModel';
import { authorizedUser } from 'Store/Selectors/AuthSelector';
import { drivingCategories } from 'Store/Selectors/UserSelector';
import { getDrivingCategory, setUserCategory } from 'Store/Actions/User';
import { getAuthorizedUser } from 'Store/Actions/Auth';

type ConnectedP = {
  authorizedUser: User;
  drivingCategories: Array<drivingCategoryType>;
};

type DispatchedP = {
  actions: {
    getDrivingCategory: () => (dispatch: any) => Promise<boolean>;
    setUserCategory: (categoryId: number, firstTime) => (dispatch: any) => Promise<boolean>;
    getAuthorizedUser: () => (dispatch: any) => Promise<any>;
  };
};

const mapStateToProps = (state) => ({
  authorizedUser: authorizedUser(state),
  drivingCategories: drivingCategories(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      getDrivingCategory,
      setUserCategory,
      getAuthorizedUser,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(MyProfileCategory);
